// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === WALLET CONTROLS === */
.wallet-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    padding: 1rem;
    border-radius: 12px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
    border: 1px solid #e2e8f0;
    margin-bottom: 2rem;
}

.wallet-tabs {
    display: flex;
    gap: 0.5rem;
}

.w-tab {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: transparent;
    border: none;
    color: #64748b;
    padding: 0.75rem 1.25rem;
    border-radius: 8px;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    transition: 0.2s;
}

.w-tab:hover {
    background: #f1f5f9;
    color: #1e293b;
}

.w-tab.active {
    background: #1e293b;
    color: white;
}

/* NEW: Groups the action buttons together */
.wallet-actions-group {
    display: flex;
    gap: 0.75rem;
    align-items: center;
}

.wallet-list-container {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    border: 1px solid #e2e8f0;
    min-height: 400px;
}

.wallet-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 300px;
    color: #94a3b8;
    font-size: 1.1rem;
}

/* === WALLET FEED (COMPACT DESIGN) === */
.wallet-feed {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
}

.wallet-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    background: #f8fafc;
    transition: 0.2s;
}

.wallet-card:hover {
    border-color: #cbd5e1;
    background: white;
}

.w-card-left {
    display: flex;
    align-items: center;
    gap: 0.85rem;
    min-width: 0;
}

.w-icon {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.w-icon svg {
    width: 20px;
    height: 20px;
}

.w-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.w-info h4 {
    margin: 0 0 0.15rem 0;
    color: #1e293b;
    font-size: 0.95rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.w-info p {
    margin: 0;
    color: #64748b;
    font-size: 0.85rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.w-reason {
    font-style: italic;
    margin-top: 0.15rem !important;
    color: #94a3b8 !important;
    font-size: 0.8rem !important;
}

.w-card-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.4rem;
    flex-shrink: 0;
    margin-left: 1rem;
}

.w-amount-block {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.w-amount-block h3 {
    margin: 0;
    font-size: 1.15rem;
    text-align: right;
    font-weight: 800;
}

.w-status {
    font-size: 0.7rem;
    font-weight: 700;
    padding: 0.15rem 0.5rem;
    border-radius: 4px;
    text-transform: uppercase;
    display: inline-block;
    margin-top: 0.25rem;
}

.s-green {
    background: #dcfce7;
    color: #15803d;
}

.s-red {
    background: #fee2e2;
    color: #b91c1c;
}

.s-gray {
    background: #f1f5f9;
    color: #64748b;
}

/* === ACTION BUTTONS === */
.w-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 0.25rem;
}

.tx-action-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    padding: 0.4rem 0.85rem;
    border-radius: 6px;
    font-weight: 700;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid transparent;
}

.btn-confirm {
    background: #ecfdf5;
    color: #059669;
    border-color: #a7f3d0;
}

.btn-confirm:hover {
    background: #10b981;
    color: white;
    border-color: #10b981;
    transform: translateY(-2px);
    box-shadow: 0 4px 6px -1px rgba(16, 185, 129, 0.2);
}

.btn-cancel {
    background: #fef2f2;
    color: #dc2626;
    border-color: #fecaca;
}

.btn-cancel:hover {
    background: #ef4444;
    color: white;
    border-color: #ef4444;
    transform: translateY(-2px);
    box-shadow: 0 4px 6px -1px rgba(239, 68, 68, 0.2);
}

.send-cash-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

/* === CONFIRM DIALOG MODAL === */
.confirm-dialog-card {
    text-align: center;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2.5rem 2rem;
}

.confirm-icon-wrapper {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.25rem;
}

.confirm-dialog-card h3 {
    margin: 0 0 0.75rem 0;
    font-size: 1.4rem;
    color: #1e293b;
    font-weight: 800;
}

.confirm-dialog-card p {
    margin: 0;
    color: #64748b;
    line-height: 1.5;
    font-size: 1.05rem;
}

.btn-danger-fill {
    background: #ef4444 !important;
    color: white !important;
}

.btn-danger-fill:hover:not(:disabled) {
    background: #dc2626 !important;
}

.btn-success-fill {
    background: #10b981 !important;
    color: white !important;
}

.btn-success-fill:hover:not(:disabled) {
    background: #059669 !important;
}

/* === CUSTOM DROPDOWN === */
.custom-dropdown-container {
    position: relative;
    width: 100%;
}

.custom-dropdown-trigger {
    width: 100%;
    padding: 0.85rem 1rem;
    border: 2px solid #cbd5e1;
    border-radius: 10px;
    background: white;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.2s ease;
    -webkit-user-select: none;
            user-select: none;
}

.custom-dropdown-trigger:hover {
    border-color: #94a3b8;
}

.custom-dropdown-trigger.open {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.placeholder-text {
    color: #94a3b8;
    font-size: 1rem;
}

.dropdown-arrow {
    color: #64748b;
    transition: transform 0.3s ease;
}

.dropdown-arrow.rotated {
    transform: rotate(180deg);
}

.selected-emp-display {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.selected-emp-name {
    font-size: 1.05rem;
    color: #1e293b;
    font-weight: 600;
}

.custom-dropdown-menu {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    max-height: 250px;
    overflow-y: auto;
    z-index: 50;
    animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-5px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.custom-dropdown-item {
    padding: 0.85rem 1rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    cursor: pointer;
    border-bottom: 1px solid #f1f5f9;
    transition: background 0.2s ease;
}

.custom-dropdown-item:last-child {
    border-bottom: none;
}

.custom-dropdown-item:hover {
    background: #f8fafc;
}

.custom-dropdown-item.selected {
    background: #eff6ff;
}

.emp-avatar-mini {
    background: #e2e8f0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #475569;
    flex-shrink: 0;
}

.custom-dropdown-item.selected .emp-avatar-mini {
    background: #3b82f6;
    color: white;
}

.emp-drop-info {
    display: flex;
    flex-direction: column;
}

.emp-drop-info h4 {
    margin: 0;
    font-size: 1rem;
    color: #1e293b;
}

.emp-drop-info span {
    font-size: 0.85rem;
    color: #64748b;
}

.dropdown-empty {
    padding: 1.5rem;
    text-align: center;
    color: #94a3b8;
    font-style: italic;
}

/* Modal specific icons */
.modal-icon-wrapper {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.bg-blue-light {
    background: #eff6ff;
}

.text-blue {
    color: #2563eb;
}

/* === RESPONSIVE MOBILE FIXES === */
@media (max-width: 768px) {
    .wallet-controls {
        flex-direction: column;
        align-items: stretch;
        gap: 1rem;
    }

    .wallet-tabs {
        width: 100%;
        flex-direction: column;
    }

    .wallet-actions-group {
        flex-direction: column;
        width: 100%;
    }

    .wallet-actions-group button {
        width: 100%;
    }

    .wallet-card {
        flex-direction: row;
        align-items: flex-start;
        padding: 0.75rem;
        gap: 0.5rem;
    }

    .w-card-left {
        gap: 0.75rem;
    }

    .w-icon {
        width: 32px;
        height: 32px;
        margin-top: 0.1rem;
    }

    .w-icon svg {
        width: 16px;
        height: 16px;
    }

    .w-card-right {
        margin-left: 0.5rem;
    }

    .tx-action-btn {
        width: auto;
    }

    .confirm-dialog-card {
        padding: 2rem 1.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/employee/CashTransfers.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8CAA8C;IAC9C,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,4CAA4C;AAC5C;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,iBAAiB;AACrB;;AAEA,yCAAyC;AACzC;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,2BAA2B;IAC3B,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,2BAA2B;IAC3B,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,mFAAmF;IACnF,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA,yBAAyB;AACzB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,oCAAoC;AACpC;IACI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,oBAAoB;IACxB;AACJ","sourcesContent":["/* === WALLET CONTROLS === */\n.wallet-controls {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: white;\n    padding: 1rem;\n    border-radius: 12px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);\n    border: 1px solid #e2e8f0;\n    margin-bottom: 2rem;\n}\n\n.wallet-tabs {\n    display: flex;\n    gap: 0.5rem;\n}\n\n.w-tab {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: transparent;\n    border: none;\n    color: #64748b;\n    padding: 0.75rem 1.25rem;\n    border-radius: 8px;\n    font-weight: 600;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: 0.2s;\n}\n\n.w-tab:hover {\n    background: #f1f5f9;\n    color: #1e293b;\n}\n\n.w-tab.active {\n    background: #1e293b;\n    color: white;\n}\n\n/* NEW: Groups the action buttons together */\n.wallet-actions-group {\n    display: flex;\n    gap: 0.75rem;\n    align-items: center;\n}\n\n.wallet-list-container {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    border: 1px solid #e2e8f0;\n    min-height: 400px;\n}\n\n.wallet-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 300px;\n    color: #94a3b8;\n    font-size: 1.1rem;\n}\n\n/* === WALLET FEED (COMPACT DESIGN) === */\n.wallet-feed {\n    display: flex;\n    flex-direction: column;\n    gap: 0.6rem;\n}\n\n.wallet-card {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.75rem 1rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    background: #f8fafc;\n    transition: 0.2s;\n}\n\n.wallet-card:hover {\n    border-color: #cbd5e1;\n    background: white;\n}\n\n.w-card-left {\n    display: flex;\n    align-items: center;\n    gap: 0.85rem;\n    min-width: 0;\n}\n\n.w-icon {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.w-icon svg {\n    width: 20px;\n    height: 20px;\n}\n\n.w-info {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.w-info h4 {\n    margin: 0 0 0.15rem 0;\n    color: #1e293b;\n    font-size: 0.95rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.w-info p {\n    margin: 0;\n    color: #64748b;\n    font-size: 0.85rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.w-reason {\n    font-style: italic;\n    margin-top: 0.15rem !important;\n    color: #94a3b8 !important;\n    font-size: 0.8rem !important;\n}\n\n.w-card-right {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0.4rem;\n    flex-shrink: 0;\n    margin-left: 1rem;\n}\n\n.w-amount-block {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n}\n\n.w-amount-block h3 {\n    margin: 0;\n    font-size: 1.15rem;\n    text-align: right;\n    font-weight: 800;\n}\n\n.w-status {\n    font-size: 0.7rem;\n    font-weight: 700;\n    padding: 0.15rem 0.5rem;\n    border-radius: 4px;\n    text-transform: uppercase;\n    display: inline-block;\n    margin-top: 0.25rem;\n}\n\n.s-green {\n    background: #dcfce7;\n    color: #15803d;\n}\n\n.s-red {\n    background: #fee2e2;\n    color: #b91c1c;\n}\n\n.s-gray {\n    background: #f1f5f9;\n    color: #64748b;\n}\n\n/* === ACTION BUTTONS === */\n.w-actions {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 0.25rem;\n}\n\n.tx-action-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.35rem;\n    padding: 0.4rem 0.85rem;\n    border-radius: 6px;\n    font-weight: 700;\n    font-size: 0.85rem;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: 1px solid transparent;\n}\n\n.btn-confirm {\n    background: #ecfdf5;\n    color: #059669;\n    border-color: #a7f3d0;\n}\n\n.btn-confirm:hover {\n    background: #10b981;\n    color: white;\n    border-color: #10b981;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 6px -1px rgba(16, 185, 129, 0.2);\n}\n\n.btn-cancel {\n    background: #fef2f2;\n    color: #dc2626;\n    border-color: #fecaca;\n}\n\n.btn-cancel:hover {\n    background: #ef4444;\n    color: white;\n    border-color: #ef4444;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 6px -1px rgba(239, 68, 68, 0.2);\n}\n\n.send-cash-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n\n/* === CONFIRM DIALOG MODAL === */\n.confirm-dialog-card {\n    text-align: center;\n    max-width: 400px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 2.5rem 2rem;\n}\n\n.confirm-icon-wrapper {\n    width: 72px;\n    height: 72px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1.25rem;\n}\n\n.confirm-dialog-card h3 {\n    margin: 0 0 0.75rem 0;\n    font-size: 1.4rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n.confirm-dialog-card p {\n    margin: 0;\n    color: #64748b;\n    line-height: 1.5;\n    font-size: 1.05rem;\n}\n\n.btn-danger-fill {\n    background: #ef4444 !important;\n    color: white !important;\n}\n\n.btn-danger-fill:hover:not(:disabled) {\n    background: #dc2626 !important;\n}\n\n.btn-success-fill {\n    background: #10b981 !important;\n    color: white !important;\n}\n\n.btn-success-fill:hover:not(:disabled) {\n    background: #059669 !important;\n}\n\n/* === CUSTOM DROPDOWN === */\n.custom-dropdown-container {\n    position: relative;\n    width: 100%;\n}\n\n.custom-dropdown-trigger {\n    width: 100%;\n    padding: 0.85rem 1rem;\n    border: 2px solid #cbd5e1;\n    border-radius: 10px;\n    background: white;\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    transition: all 0.2s ease;\n    user-select: none;\n}\n\n.custom-dropdown-trigger:hover {\n    border-color: #94a3b8;\n}\n\n.custom-dropdown-trigger.open {\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.placeholder-text {\n    color: #94a3b8;\n    font-size: 1rem;\n}\n\n.dropdown-arrow {\n    color: #64748b;\n    transition: transform 0.3s ease;\n}\n\n.dropdown-arrow.rotated {\n    transform: rotate(180deg);\n}\n\n.selected-emp-display {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.selected-emp-name {\n    font-size: 1.05rem;\n    color: #1e293b;\n    font-weight: 600;\n}\n\n.custom-dropdown-menu {\n    position: absolute;\n    top: calc(100% + 8px);\n    left: 0;\n    right: 0;\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n    max-height: 250px;\n    overflow-y: auto;\n    z-index: 50;\n    animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-5px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.custom-dropdown-item {\n    padding: 0.85rem 1rem;\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    cursor: pointer;\n    border-bottom: 1px solid #f1f5f9;\n    transition: background 0.2s ease;\n}\n\n.custom-dropdown-item:last-child {\n    border-bottom: none;\n}\n\n.custom-dropdown-item:hover {\n    background: #f8fafc;\n}\n\n.custom-dropdown-item.selected {\n    background: #eff6ff;\n}\n\n.emp-avatar-mini {\n    background: #e2e8f0;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #475569;\n    flex-shrink: 0;\n}\n\n.custom-dropdown-item.selected .emp-avatar-mini {\n    background: #3b82f6;\n    color: white;\n}\n\n.emp-drop-info {\n    display: flex;\n    flex-direction: column;\n}\n\n.emp-drop-info h4 {\n    margin: 0;\n    font-size: 1rem;\n    color: #1e293b;\n}\n\n.emp-drop-info span {\n    font-size: 0.85rem;\n    color: #64748b;\n}\n\n.dropdown-empty {\n    padding: 1.5rem;\n    text-align: center;\n    color: #94a3b8;\n    font-style: italic;\n}\n\n/* Modal specific icons */\n.modal-icon-wrapper {\n    width: 72px;\n    height: 72px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.bg-blue-light {\n    background: #eff6ff;\n}\n\n.text-blue {\n    color: #2563eb;\n}\n\n/* === RESPONSIVE MOBILE FIXES === */\n@media (max-width: 768px) {\n    .wallet-controls {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 1rem;\n    }\n\n    .wallet-tabs {\n        width: 100%;\n        flex-direction: column;\n    }\n\n    .wallet-actions-group {\n        flex-direction: column;\n        width: 100%;\n    }\n\n    .wallet-actions-group button {\n        width: 100%;\n    }\n\n    .wallet-card {\n        flex-direction: row;\n        align-items: flex-start;\n        padding: 0.75rem;\n        gap: 0.5rem;\n    }\n\n    .w-card-left {\n        gap: 0.75rem;\n    }\n\n    .w-icon {\n        width: 32px;\n        height: 32px;\n        margin-top: 0.1rem;\n    }\n\n    .w-icon svg {\n        width: 16px;\n        height: 16px;\n    }\n\n    .w-card-right {\n        margin-left: 0.5rem;\n    }\n\n    .tx-action-btn {\n        width: auto;\n    }\n\n    .confirm-dialog-card {\n        padding: 2rem 1.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
